import React from 'react'

import { selectExamCardsByFilters } from '../selectors'

import style from './CardsList.module.css'
import { ExamCard } from './ExamCard/ExamCard'

import { useAppDispatch, useAppSelector } from 'common/hooks'
import { addFilter } from 'features/filter'

type PropsType = {}

export const CardsList = ({}: PropsType) => {
  const dispatch = useAppDispatch()
  const cards = useAppSelector(selectExamCardsByFilters)

  const addFilterHandler = (filter: string) => {
    dispatch(addFilter(filter))
  }

  return (
    <ul className={style['cards-list']}>
      {cards.map(card => (
        <ExamCard key={card.id} card={card} addFilterHandler={addFilterHandler} />
      ))}
    </ul>
  )
}
